'use es6';

import { FONT_SIZES } from 'ContentUtils/constants/FontSettings';
export const WEBFONTS_IMPORT = "@import url('https://fonts.googleapis.com/css?family={{fontsList}}');";
export const DEFAULT_LINK_COLOR = '#197fc4';
export const DEFAULT_HEADING_ONE_SIZE = '28';
export const DEFAULT_HEADING_TWO_SIZE = '22';
export const LINE_HEIGHT_OPTIONS = [100, 115, 125, 150, 175, 200, 250, 300, 400].map(v => ({
  text: `${v / 100}`,
  value: `${v}%`
}));
export const DEFAULT_LINE_HEIGHT = '175%';
export const STYLE_SHEET = `
  body, td {
    font-family: {{primary_font}};
    color: {{primary_font_color}};
    font-size: {{primary_font_size}}px;
  }
  .hubspot table, .hubspot td {
    font-family: inherit;
    color: inherit;
    font-size: inherit;
  }
  .hse-secondary {
    font-family: {{secondary_font}};
    font-size: {{secondary_font_size}}px;
    color: {{secondary_font_color}};
  }
  .hs_cos_wrapper_type_rich_text p, .hs_cos_wrapper_type_rich_text div, .hs_cos_wrapper_type_rich_text ol, .hs_cos_wrapper_type_rich_text ul, .hs_cos_wrapper_type_rich_text blockquote,
  .hs_cos_wrapper_type_inline_rich_text p, .hs_cos_wrapper_type_inline_rich_text div, .hs_cos_wrapper_type_inline_rich_text ul, .hs_cos_wrapper_type_inline_rich_text blockquote,
  h1,h2,h3,h4,h5,h6 {
    line-height: {{primary_font_line_height}};
  }

  .hse-body-background {
    background-color: {{background_color}};
  }
  .hse-border {
    border-left: {{body_border_width}}px solid {{body_border_color}};
    border-right: {{body_border_width}}px solid {{body_border_color}};
  }
  .hse-border-bottom {
    border-bottom: {{body_border_width}}px solid {{body_border_color}};
  }
  .hse-border-top {
    border-top: {{body_border_width}}px solid {{body_border_color}};
  }

  .hse-section {
    padding-left: {{layout_padding.left.value}}{{layout_padding.left.units}};
    padding-right: {{layout_padding.right.value}}{{layout_padding.right.units}};
  }

  .hs_cos_wrapper_type_rich_text h1, .hs_rss_email_entries_table h1 {
    font-family: {{heading_one_font.font}};
    font-size: {{heading_one_font.size}}px;
    color: {{heading_one_font.color}};
  }
  .hs_cos_wrapper_type_rich_text h2, .hs_rss_email_entries_table h2 {
    font-family: {{heading_two_font.font}};
    font-size: {{heading_two_font.size}}px;
    color: {{heading_two_font.color}};
  }
  .hs_cos_wrapper_type_rich_text a, .hs_rss_email_entries_table a {
    color: {{computed_links_font_color}};
    text-decoration: {{computed_links_text_decoration}};
    font-style: {{computed_links_font_style}};
    font-weight: {{computed_links_font_weight}};
  }

  #cos_layout_builder {
    background: {{background_image}};
    background-repeat: {{background_repeat}};
    background-size: {{background_size}};
    background-position: {{background_position}};
  }
`;
export const MOBILE_STYLE_SHEET = `
  @media only screen and (max-width: 639px) {
    .hse-body-background {
      background-color: {{background_color}} !important;
    }
  }

  @media only screen and (max-width: 639px) {
    .hse-border {
      border-width: {{body_border_width}}px !important;
      border-color: {{body_border_color}} !important;
    }
  }

  @media only screen and (max-width: 639px) {
    #cos_layout_builder {
      background: {{background_image}} !important;
      background-repeat: {{background_repeat}} !important;
      background-size: {{background_size}} !important;
      background-position: {{background_position}} !important;
    }
  }
`;
export const FONT_SIZE_OPTIONS = FONT_SIZES.map(val => {
  return {
    text: `${val}px`,
    value: val.toString()
  };
});